export default "__VITE_ASSET__BbimUSAy__"